import { InputNumber as InputNumberAntd } from 'antd';
import styled from 'styled-components';

import FormField from '../Field';

const StyledInputNumber = styled(InputNumberAntd)`
  width: 100%;
`;

const InputNumber = FormField<string>(StyledInputNumber);

export default InputNumber;
